import * as React from 'react'

import { Box, InfoDot, Text } from '@factorialco/deprecated-design-system'

import { UnassignedShiftSummary } from 'modules/shift_management/hooks/useCalculateSummaryUnassignedShifts'

interface Props {
  unassignedShiftsSummary: UnassignedShiftSummary[]
}

const MoreShiftsTooltip = ({ unassignedShiftsSummary }: Props) => {
  return (
    <Box>
      {unassignedShiftsSummary.map((shiftSummary) => (
        <Box
          key={shiftSummary.color.toString()}
          flexDirection="row"
          alignItems="center"
          width="full"
        >
          <Box flexDirection="row" gap="s8" alignItems="center">
            <Box>
              <InfoDot size="small" color={shiftSummary.color} />
            </Box>
            <Text size="100" color="grey100" ellipsis>
              {shiftSummary.title}:
            </Text>
            <Text size="100" color="grey100">
              {shiftSummary.counter}
            </Text>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default MoreShiftsTooltip
